import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * A new page should start at its beginning. Without this the browser keeps the
 * scroll offset across a route change, so leaving an article halfway through
 * drops you halfway into whatever you opened next.
 *
 * Cases deliberately left alone:
 * - a URL carrying a #hash, which is a deep link the page scrolls to itself
 * - back and forward, where the browser restores where the reader was
 * - internal tab / section switches within workspaces (e.g. /doctor/* or /dashboard/*)
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    const prev = prevPathnameRef.current;
    prevPathnameRef.current = pathname;

    if (hash || navigationType === 'POP') return;

    // Do not jump scroll when switching tabs inside workspaces
    const isDoctorTab = prev && prev.startsWith('/doctor') && pathname.startsWith('/doctor');
    const isDashboardTab = prev && prev.startsWith('/dashboard') && pathname.startsWith('/dashboard');
    if (isDoctorTab || isDashboardTab) {
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}
